module.exports = __webpack_public_path__ + "img/visa.ed1a5fed.svg";